const removeLocalStorage = (key) => {
	try {
		localStorage.removeItem(key);
	} catch (error) {
		console.error(error);
	}
};

export default removeLocalStorage;
